import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ruc-confirmacao-dialog',
  templateUrl: './ruc-confirmacao-dialog.component.html',
  styleUrls: ['./ruc-confirmacao-dialog.component.scss'],
})
export class RucConfirmacaoDialogComponent {

  @Input() visible = false;
  @Input() resultados: any[] = [];
  @Input() origem: 'interna' | 'externa' | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmar = new EventEmitter<any>();
  @Output() recusar = new EventEmitter<void>();

  pessoaSelecionada: any = null;

  constructor(public translate: TranslateService) {}

  onConfirmar(): void {
    const pessoa = this.pessoaSelecionada || (this.resultados.length === 1 ? this.resultados[0] : null);
    if (!pessoa) return;
    this.confirmar.emit(pessoa);
  }

  onRecusar(): void {
    this.recusar.emit();
    this.fechar();
  }

  onVisibleChange(value: boolean): void {
    this.visible = value;
    this.visibleChange.emit(value);
  }

  private fechar(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.pessoaSelecionada = null;
  }
}
